import { useAccountInviteUserMutation } from '~/generated/graphql';

export function useInviteUser() {
  const [inviteUser, { loading }] = useAccountInviteUserMutation();

  return {
    inviteUser,
    loading,
  };
}
